import { Box, Typography, Tooltip } from "@mui/material";
import { HiOutlineTranslate } from "react-icons/hi";
import { useLanguage } from "../context/LanguageContext";

const LanguageSwitcher = () => {
  const { language, changeLanguage } = useLanguage();

  // Map language codes to full language names for better readability
  const languageNames = {
    en: "English",
    nl: "Dutch",
  };

  const toggleLanguage = () => {
    changeLanguage(language === "en" ? "nl" : "en");
  };

  return (
    <Tooltip
      arrow
      title={`Switch to ${language === "en" ? "Dutch" : "English"}`}
    >
      <Box
        onClick={toggleLanguage}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: "pointer",
          color: "#333",
          padding: "8px 12px",
          borderRadius: "22px",
          transition: "background-color 0.2s",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.05)",
          },
        }}
        aria-label="Change language"
      >
        <HiOutlineTranslate size={20} />
        <Typography fontSize={15} fontWeight={500}>
          {languageNames[language]}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default LanguageSwitcher;
